import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { PanelService } from 'panel/services/panel.service'
import { NotifyService } from 'common/util/services/notify.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class CompareOp extends BaseOperation {
  icon = 'far fa-columns'
  showInSelectionToolbar = true
  // showInContextMenu = true
  supportsMultiple = true
  supportsBundles = true
  weight = 60

  constructor (
    private router: Router,
    private translate: TranslateService,
    private panel: PanelService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Compare')
  }

  isVisibleFor ({ bundles }) {
    return bundles.length > 1 && !this.panel.active
  }

  isEnabledFor ({ bundles }) {
    return this._getUniqueIDs(bundles).length > 1
  }

  async run ({ bundles }, context) {
    const uniqueIDs = this._getUniqueIDs(bundles)
    if (uniqueIDs.length > 4) {
      this.notify.warning(this.translate.instant('Can\'t compare more than 4 videos'))
    } else {
      this.router.navigateByUrl(`/media/compare/${context.root.id}/${uniqueIDs.join(',')}`)
    }
  }

  _getUniqueIDs (bundles) {
    const assets = bundles.filter(x => x?.asset?.proxiesGenerated && x?.asset?.type === 'video').map(x => x.asset)
    return [...new Set(assets.map(x => x.id))]
  }
}

MediaOperationsService.register(CompareOp)
